const getType = (document, focusBlock) => {
  let tempkey = focusBlock.key;
  while (
    document.getParent(tempkey).type === 'list_item' ||
    document.getParent(tempkey).type === 'unordered_list'
  ) {
    tempkey = document.getParent(tempkey).key;
  }
  return document.getParent(tempkey).type;
};

export default (editor) => {
  const { document, focusBlock, selection } = editor.value;
  const type = getType(document, focusBlock);
  editor.moveToStartOfNextBlock();
  const newType = getType(editor.value.document, editor.value.focusBlock);
  editor.select(selection);
  return type !== newType;
};
